import React, { Component } from 'react';
import LeftArrow            from '../LeftArrow/LeftArrow';
import RightArrow           from '../RightArrow/RightArrow';
import ToggleSettings       from '../ToggleSettings/ToggleSettings';
import Settings             from '../Settings/Settings';
import AutoPlay             from '../AutoPlay/AutoPlay';
import VideoSlide           from '../VideoSlide/VideoSlide';
import ImgSlide             from '../ImgSlide/ImgSlide';
import Schedule             from '../Schedule/Schedule';
import './Slider.css';

import fscreen from 'fscreen';

class Slider extends Component {
    state = {
        slides: this.props.slides,
        currentIndex: 0,
        settingsVisible: false,
        componentsVisible: true,
        autoplay: false,
        timerId: 0,
        isFullScreen: false,
        timeOut: 10000
    };

    componentDidUpdate = (prevProps, prevState) => {
        const { autoplay, timeOut, currentIndex } = this.state;

        if (autoplay && prevState.autoplay !== autoplay) {
            clearTimeout(this.state.timerId);

            let timerId = setTimeout(() => {
                this.goToNextSlide();
            }, timeOut);

            this.setState({ timerId });
        }

        if (autoplay && prevState.currentIndex !== currentIndex) {
            let timerId = clearTimeout(this.state.timerId);
            this.setState({ timerId });

            timerId = setTimeout(() => {
                this.goToNextSlide();
            }, timeOut);

            this.setState({ timerId });
        }

        if (!autoplay && prevState.autoplay !== autoplay) {
            let timerId = clearTimeout(this.state.timerId);
            this.setState({ timerId });
        }
    };

    componentDidMount() {
        const { timeOut, currentIndex } = this.state;

        const handler = () => {
            if (fscreen.fullscreenElement !== null) {
                // Войти в полноэкранный режим

                // Убрать или показать навигацию по другим страницам
                document.querySelector('.menu-toggle').classList.toggle('invisible');

                // Узнаем длительность для текущего слайда, если нет, то берем значение по умолчанию
                if (this.state.slides[currentIndex]) {
                    let duration = this.state.slides[currentIndex].duration || timeOut;
                    this.setState({
                        timeOut: duration
                    });
                }

                this.setState(prevState => ({
                    autoplay: !prevState.autoplay,
                    componentsVisible: !prevState.componentsVisible,
                    isFullScreen: !prevState.isFullScreen
                }));
            } else {
                // Выйти из полноэкранного режима

                // Убрать или показать навигацию по другим страницам
                document.querySelector('.menu-toggle').classList.toggle('invisible');

                this.setState(prevState => ({
                    autoplay: !prevState.autoplay,
                    componentsVisible: !prevState.componentsVisible,
                    isFullScreen: !prevState.isFullScreen
                }));
            }
        };

        if (fscreen.fullscreenEnabled) {
            fscreen.addEventListener('fullscreenchange', handler, false);
        }

        document.addEventListener('keydown', event => this.handleKeyboard(event), false);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') {
                event.preventDefault();
                this.goToNextSlide();
            }

            if (event.key === 'ArrowLeft') {
                event.preventDefault();
                this.goToPrevSlide();
            }
        }, false);
    }

    handleKeyboard = event => {
        if (event.code === 'ArrowRight') {
            event.preventDefault();
            this.goToNextSlide();
        }

        if (event.code === 'ArrowLeft') {
            event.preventDefault();
            this.goToPrevSlide();
        }

        if (event.code === 'Space') {
            event.preventDefault();
            this.handleRequestFullScreen();
        }
    };

    handleDeleteSlide = slideIndex => {
        let slides = [...this.state.slides];
        slides.splice(slideIndex, 1);
        this.setState({ slides });

        if (typeof slides[this.state.currentIndex] === 'undefined') {
            this.setState({ currentIndex: 0 });
        }
    };

    goToPrevSlide = () => {
        if (this.state.currentIndex === 0) {
            this.setState({ currentIndex: 0 });
            return;
        }

        this.setState(prevState => ({
            currentIndex: prevState.currentIndex - 1,
            isPlay: !prevState.isPlay
        }));
    };

    goToNextSlide = () => {
        const { timeOut, currentIndex, autoplay, slides } = this.state;

        const isLastElement = this.state.slides.length - 1 === currentIndex;
        if (isLastElement) {
            // Если нажат плей, найдем скорость первого слайда
            if (autoplay) {
                let duration = this.state.slides[0].duration || timeOut;
                this.setState({ timeOut: duration });
            }

            this.setState({ currentIndex: 0 });
            return;
        }

        // Если нажали плей, найдем скорость для следуюшего слайда
        if (autoplay) {
            let duration = timeOut;
            if (typeof this.state.slides[currentIndex + 1] !== 'undefined') {
                duration = this.state.slides[currentIndex + 1].duration || timeOut;
            }
            this.setState({ timeOut: duration });
        }

        if (typeof slides[currentIndex] !== 'undefined') {
            this.setState(prevState => ({
                currentIndex: prevState.currentIndex + 1
            }));
        } else {
            this.setState({ currentIndex: 0 });
        }
    };

    toggleSetting = () => {
        this.setState(prevState => ({
            settingsVisible: !prevState.settingsVisible
        }));
    };

    toggleAutoplay = () => {
        this.setState(prevState => ({
            autoplay: !prevState.autoplay
        }));
    };

    handleRequestFullScreen = () => {
        fscreen.requestFullscreen(document.documentElement);
    };

    handleClose = () => {
        this.setState({
            settingsVisible: false
        });
    };

    render() {
        const slides = this.state.slides.map((slide, index) => {
            if (slide.type === 'video') {
                return (
                    <VideoSlide
                        key={ index }
                        isPlay={ index === this.state.currentIndex && this.state.autoplay }
                        isCurrentSlide={ index === this.state.currentIndex }
                        source={ slide }
                    />
                );
            } else if (slide.type === 'image') {
                return (
                    <ImgSlide
                        key={ index }
                        isCurrentSlide={ index === this.state.currentIndex }
                        source={ slide }
                    />
                );
            } else if (slide.type === 'schedule') {
                return (
                    <Schedule
                        key={ index }
                        isCurrentSlide={ index === this.state.currentIndex }
                        source={ slide }
                    />
                );
            }
        });

        return (
            <div className="b-slider">
                <ToggleSettings
                    visible={ this.state.componentsVisible }
                    toggleSetting={ this.toggleSetting }
                />

                <AutoPlay
                    visible={ this.state.componentsVisible }
                    toggleAutoplay={ this.handleRequestFullScreen }
                />

                <Settings
                    currentSlide={ this.state.currentIndex }
                    onClose={ this.handleClose }
                    visible={ this.state.settingsVisible }
                    autoplay={ this.state.autoplay }
                    toggleAutoplay={ this.toggleAutoplay }
                    deleteSlide={ this.handleDeleteSlide }
                    slides={ slides }
                />

                { slides }

                {
                    this.state.currentIndex !== 0
                        ? <LeftArrow
                            visible={ this.state.componentsVisible }
                            goToPrevSlide={ this.goToPrevSlide }
                        />
                        : null
                }

                <RightArrow
                    visible={ this.state.componentsVisible }
                    goToNextSlide={ this.goToNextSlide }
                />
            </div>
        );
    }
}

export default Slider;
